export function formatVosTravelTime(
  hours?: number | null,
  minutes?: number | null
): string {
  if ((hours == null || hours === 0) && (minutes == null || minutes === 0)) return '-'
  return `${hours ?? 0}h ${minutes ?? 0}m`
}

export type OsiBillingFlags = {
  isTimeChargeableForInterpreter: boolean
  isTimeChargeableForClient: boolean
  isMileagePayableForInterpreter: boolean
  isMileageChargeableForClient: boolean
  isTravelTimePayableForInterpreter: boolean
  isTravelTimeChargeableForClient: boolean
}

function readOsiBoolean(data: Record<string, unknown>, ...keys: string[]): boolean | undefined {
  for (const key of keys) {
    const value = data[key]
    if (typeof value === 'boolean') return value
  }
  return undefined
}

export function resolveOsiBillingFlags(
  data: Record<string, unknown> | null | undefined,
  fallback = false
): OsiBillingFlags {
  const source = data ?? {}
  return {
    isTimeChargeableForInterpreter:
      readOsiBoolean(
        source,
        'isTimeChargeableForInterpreter',
        'IsTimeChargeableForInterpreter',
        'interpreterIsTimeChargeableForInterpreter',
        'InterpreterIsTimeChargeableForInterpreter'
      ) ?? fallback,
    isTimeChargeableForClient:
      readOsiBoolean(
        source,
        'isTimeChargeableForClient',
        'IsTimeChargeableForClient',
        'interpreterIsTimeChargeableForClient',
        'InterpreterIsTimeChargeableForClient'
      ) ?? fallback,
    isMileagePayableForInterpreter:
      readOsiBoolean(
        source,
        'isMileagePayableForInterpreter',
        'IsMileagePayableForInterpreter',
        'interpreterIsMileagePayableForInterpreter',
        'InterpreterIsMileagePayableForInterpreter'
      ) ?? fallback,
    isMileageChargeableForClient:
      readOsiBoolean(
        source,
        'isMileageChargeableForClient',
        'IsMileageChargeableForClient',
        'interpreterIsMileageChargeableForClient',
        'InterpreterIsMileageChargeableForClient'
      ) ?? fallback,
    isTravelTimePayableForInterpreter:
      readOsiBoolean(
        source,
        'isTravelTimePayableForInterpreter',
        'IsTravelTimePayableForInterpreter',
        'interpreterIsTravelTimePayableForInterpreter',
        'InterpreterIsTravelTimePayableForInterpreter'
      ) ?? fallback,
    isTravelTimeChargeableForClient:
      readOsiBoolean(
        source,
        'isTravelTimeChargeableForClient',
        'IsTravelTimeChargeableForClient',
        'interpreterIsTravelTimeChargeableForClient',
        'InterpreterIsTravelTimeChargeableForClient'
      ) ?? fallback,
  }
}

export type AppointmentChargeRateHours = {
  interpreterRateHour: number | ''
  clientRateHour: number | ''
}

export function resolveAppointmentChargeRateHours(
  interpreters: Array<{assignStatus?: number; appointmentCharges?: {interpreterUpdatedRate?: number; clientRate?: number}}> | null | undefined
): AppointmentChargeRateHours {
  const confirmed = interpreters?.find(
    (item) => item?.assignStatus === 3 || item?.assignStatus === 6
  )
  const charges = confirmed?.appointmentCharges
  const interpreterRate = charges?.interpreterUpdatedRate
  const clientRate = charges?.clientRate
  return {
    interpreterRateHour:
      interpreterRate != null && !Number.isNaN(Number(interpreterRate)) ? Number(interpreterRate) : '',
    clientRateHour: clientRate != null && !Number.isNaN(Number(clientRate)) ? Number(clientRate) : '',
  }
}
